import React from 'react';
import clsx from 'clsx';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';
import Button from '@/elements/Button/Button.component';
import { IProps } from './ErrorBlock.interface';
import './ErrorBlock.styles.css';

/**
 * WysiwygBlock displays a heading and rich text content, using BlockWrapper for layout.
 * Heading and text are rendered as HTML for full WYSIWYG flexibility.
 */
const ErrorBlock: React.FC<IProps> = ({
    heading,
    content,
    buttons,
    className,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper className={clsx('errorBlock', className)} {...blockWrapperProps}>
            <ContentWrapper>
                <ContentColumn className="errorBlock__content">
                    {heading && (
                        <Heading level={2} className="errorBlock__heading" html={heading} />
                    )}
                    {content && (
                        <Text className="errorBlock__text" html={content} />
                    )}
                    {buttons && buttons.length > 0 && (
                        <div className="errorBlock__buttons">
                            {buttons.map((buttonProps, index) => (
                                <div>
                                    <Button key={index} {...buttonProps} />
                                </div>
                            ))}
                        </div>
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { ErrorBlock };
